"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Modal extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }
  render() {
    const {
      buttonLabel,
      className,
      modalTitle,
      modalBody,
      cancelLabel,
      actionLabel,
      launchButton
    } = this.props;
    const {
      modal
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, launchButton ? ( /*#__PURE__*/_react.default.cloneElement(launchButton, {
      onClick: this.toggle
    })) : /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
      color: "danger",
      onClick: this.toggle
    }, buttonLabel), /*#__PURE__*/_react.default.createElement(_reactstrap.Modal, {
      isOpen: modal,
      toggle: this.toggle,
      centered: true,
      className: (0, _classnames.default)("ixn-modal ".concat(className))
    }, /*#__PURE__*/_react.default.createElement(_reactstrap.ModalHeader, {
      toggle: this.toggle
    }, modalTitle), /*#__PURE__*/_react.default.createElement(_reactstrap.ModalBody, null, modalBody), /*#__PURE__*/_react.default.createElement(_reactstrap.ModalFooter, null, /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
      color: "secondary",
      className: "ixn-modal__cancel-button",
      onClick: this.toggle
    }, "".concat(cancelLabel, " ")), /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
      color: "primary",
      className: "ixn-modal__action-button",
      onClick: this.toggle
    }, actionLabel))));
  }
}
exports.Modal = Modal;
Modal.defaultProps = {
  buttonLabel: "",
  className: "",
  modalTitle: "",
  modalBody: "",
  cancelLabel: "",
  actionLabel: "",
  launchButton: ""
};
Modal.propTypes = {
  /** Specifies the text on action button */
  actionLabel: _propTypes.default.string,
  /** Launch modal button text*/
  buttonLabel: _propTypes.default.string,
  /** Specifies the text on cancel button */
  cancelLabel: _propTypes.default.string,
  /** Specifies custom class name */
  className: _propTypes.default.string,
  /** Specifies the text of the modal header*/
  modalTitle: _propTypes.default.string,
  /** Add any HTML markup; paragraphs, images, videos, etc. */
  modalBody: _propTypes.default.string
};